import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	{
		root: {
			'&.video-6': {
				overflow: 'hidden',
			},
		},
	},
	{ name: 'Video' },
)

export default useStyles
